import http from "../common/http-config";

const apiPrefix = `Categories/`;


class CategoryService {
    async getAll() {
        return await http.get(apiPrefix).then((response) => {
          if (response.data) {
            return response.data.data;
          } else {
            return [];
          }
        });
    }
    async get(categoryId) {
        return await http.get(apiPrefix+categoryId).then((response) => {
          if (response.data) {
            return response.data.data;
          } else {
            return [];
          }
        });
    }
    async add(category) {
      //let category = {name: name, description: description, visible: visible}
      return await http.post(apiPrefix, category).then((response) => {
        return response.data;
      });
    }
    async delete(categoryId) {
      //let category = {name: name, description: description, visible: visible}
      return await http.delete(apiPrefix+categoryId).then((response) => {
        return response.data;
      });
    }
}
export default new CategoryService()